export function ProgressBar({ value, label = 'Progreso' }: { value: number; label?: string }) {
  const normalized = Math.max(0, Math.min(100, value))
  return <div className="progress-wrap">
    <div className="progress-label"><span>{label}</span><strong>{normalized}%</strong></div>
    <div className="progress-track" role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={normalized}><span style={{ width: `${normalized}%` }} /></div>
  </div>
}
